export default {
  plants: [],
  life: 0,
  activePage: "level",
  difficulty: 0,
  family: 0,
  game: 0,
  score: 0,
};
